import Slider from "@material-ui/core/Slider";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from "@material-ui/core/Checkbox";

import useContext from "../../../context";

export default function SellerPaysClosingCosts() {
  const [context, updateContext] = useContext();

  return (
    <React.Fragment>
      <div>
        <div className="quoteform__input">
          <FormControlLabel
            className="MuiCheckbox-root--alignstart"
            label={<div className="quoteform__text" style={{ color: "#000" }}>The seller is paying the closting costs</div>}
            control={
              <Checkbox
                color="primary"
                checked={context.sellerPaysClosingCosts}
                onChange={({ target: { checked } }) => updateContext((ctx) => {
                  ctx.sellerPaysClosingCosts = checked;

                  return ctx;
                })}
                value={'yes'}
                name="finance-closingcosts"
              />
            }
          />
        </div>
      </div>
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/components/SellerPaysClosingCosts.js